import { render, staticRenderFns } from "./weappEdit.vue?vue&type=template&id=31261c9e&scoped=true&"
import script from "./weappEdit.vue?vue&type=script&lang=js&"
export * from "./weappEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31261c9e",
  null
  
)

export default component.exports